import { AUTO_MOBILE_INFO } from "actions/types";
import { baseStore } from "../common/baseStore"

export default baseStore(AUTO_MOBILE_INFO)
